import React, { useState } from "react";
import { FaSearch, FaMicrophone, FaMapMarkerAlt } from "react-icons/fa";
import heroImage from "../../images/hero-image.jpg";
import "./Hero.css";

export default function Hero({ onSearch }) {
  const [searchValue, setSearchValue] = useState("");
  const [searchByLocation, setSearchByLocation] = useState("");

  const handleSearch = () => {
    if (onSearch) {
      onSearch(searchValue.trim(), searchByLocation.trim());
    }
  };

  return (
    <section className="hero-section">
      <div className="hero-bg">
        <div className="circle red"></div>
        <div className="circle navy"></div>
        <div className="circle blend"></div>
      </div>

      <div className="hero-container">
        <div className="hero-grid">
          {/* Left Side */}
          <div className="hero-left">
            <div className="wc-badge">
              <div className="dot"></div>
              <span>Connecting 10,000+ Women Entrepreneurs</span>
            </div>

            <h2 className="hero-heading">
              <span className="line1">Discover & Support</span>
              <span className="line3">
                Women-Led Businesses
                <svg viewBox="0 0 300 12" fill="none">
                  <path
                    d="M2 10C50 5, 100 2, 150 4C200 6, 250 3, 298 8"
                    stroke="currentColor"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                  />
                </svg>
              </span>
            </h2>

            <p className="hero-desc">
              Verified marketplace connecting you with trusted women entrepreneurs near you
            </p>

            {/* 🔍 Search Bar */}
            <div className="wc-search-bar">
              <div className="wc-search-input">
                <FaSearch className="wc-icon" />
                <input
                  type="text"
                  placeholder="What service do you need?"
                  value={searchValue}
                  onChange={(e) => setSearchValue(e.target.value)}
                />
                <FaMicrophone className="wc-icon wc-mic" />
              </div>

              <div className="wc-location-input">
                <FaMapMarkerAlt className="wc-icon" />
                <input
                  type="text"
                  placeholder="Location"
                  value={searchByLocation}
                  onChange={(e) => setSearchByLocation(e.target.value)}
                />
              </div>

              <button className="wc-search-btn" onClick={handleSearch}>
                <FaSearch style={{ marginRight: 8 }} />
                Search
              </button>
            </div>
          </div>

          {/* Right Side */}
          <div className="hero-right">
            <div className="image-group">
              <div className="wc-hero-card top">
                <div className="hero-avatar">A</div>
                <div>
                  <div className="name">Anita Sharma</div>
                  <div className="role">Beauty Expert</div>
                </div>
              </div>

              <div className="wc-hero-card bottom">
                <div className="hero-avatar">P</div>
                <div>
                  <div className="name">Priya Mehta</div>
                  <div className="role">Tech Consultant</div>
                </div>
              </div>

              <div className="decor decor1"></div>
              <div className="decor decor2"></div>

              <div className="image-frame">
                <div className="shine"></div>
                <img src={heroImage} alt="Women entrepreneurs" className="main-photo" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
